import React, { createContext, useContext, useState, useEffect } from 'react';
import Web3AuthCall from '@/lib/web3/Web3AuthCall';
import { useWeb3Auth } from '@web3auth/modal/react';

interface Web3ContextType {
  web3authCall: Web3AuthCall | null;
  address: string;
  isInitialized: boolean;
  initializeWeb3Auth: () => Promise<void>;
  clearWeb3Auth: () => void;
}

export const Web3Context = createContext<Web3ContextType | undefined>(undefined);

export const Web3Provider = ({ children }: { children: React.ReactNode }) => {
  const { web3Auth, isConnected, provider } = useWeb3Auth();
  const [web3authCall, setWeb3authCall] = useState<Web3AuthCall | null>(null);
  const [address, setAddress] = useState('');
  const [isInitialized, setIsInitialized] = useState(false);

  // provider가 준비되면 자동으로 초기화
  useEffect(() => {
    // console.log(`11111111111111111111111111111111111111111111111111`);
    // console.log(`isConnected`, isConnected);
    // console.log(`web3Auth`, web3Auth);
    // console.log(`provider`, provider);
    // console.log(`isInitialized`, isInitialized);

    if (web3Auth) {
      // provider가 완전히 준비될 때까지 잠시 대기
      const timer = setTimeout(() => {
        initializeWeb3Auth();
      }, 1000); // 1초 대기

      return () => clearTimeout(timer);
    }
  }, [isConnected, web3Auth, provider, isInitialized]);

  // 새로고침 시 상태 복원
  useEffect(() => {
    if (isConnected && web3Auth) {
      restoreWeb3AuthState();
    }
  }, [isConnected, web3Auth]);

  const restoreWeb3AuthState = async () => {
    try {
      const savedAddress = localStorage.getItem('walletAddress');
      if (savedAddress && web3Auth && provider) {
        const web3Call = new Web3AuthCall(web3Auth, provider);
        await web3Call.initialize();
        setWeb3authCall(web3Call);
        setAddress(savedAddress);
        setIsInitialized(true);
      }
    } catch (error) {
      console.error('Error restoring Web3Auth state:', error);
      clearWeb3Auth();
    }
  };

  const initializeWeb3Auth = async () => {
    if (!web3Auth || !provider || isInitialized) return;

    try {
      const web3Call = new Web3AuthCall(web3Auth, provider);
      await web3Call.initialize();
      const addr = await web3Call.getAddress();

      // 주소 유효성 검증
      if (!addr || addr.length < 42) {
        throw new Error('Invalid wallet address');
      }

      setWeb3authCall(web3Call);
      setAddress(addr);
      setIsInitialized(true);

      localStorage.setItem('walletAddress', addr);
      localStorage.setItem('web3authInitialized', 'true');
    } catch (error) {
      console.error('Error initializing Web3Auth:', error);
      clearWeb3Auth();
    }
  };

  const clearWeb3Auth = () => {
    setWeb3authCall(null);
    setAddress('');
    setIsInitialized(false);
    localStorage.removeItem('walletAddress');
    localStorage.removeItem('web3authInitialized');
  };

  return (
    <Web3Context.Provider
      value={{
        web3authCall,
        address,
        isInitialized,
        initializeWeb3Auth,
        clearWeb3Auth,
      }}
    >
      {children}
    </Web3Context.Provider>
  );
};

export const useWeb3 = () => {
  const context = useContext(Web3Context);
  if (!context) {
    throw new Error('useWeb3 must be used within Web3Provider');
  }
  return context;
};
